import * as React from "react";

interface SectionProps {
  className?: string;
  shaded?: boolean;
  mobileFullWidth?: boolean;
}

export const Section: React.FunctionComponent<SectionProps> = (props) => {
  return (
    <section
      className={`bbnt_homepage_section ${props.mobileFullWidth ? "mobile-full-width" : "mobile-standard"} ${props.className ? props.className : ""}`}
    >
      <div className={`container ${
        props.shaded ? "shaded" : "not-shaded"
      }`}>
        <div className="inner-container">{props.children}</div>
      </div>
    </section>
  );
};
